import { ReactNode } from 'react';

import {
  DiscordIconHeader,
  TelegramIconHeader,
  TwitterIconHeader,
  YoutubeIconHeader,
} from '@constants/common/icons.constants';
import {
  DISCORD_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
  YOUTUBE_LINK,
} from '@constants/common/links.constants';

type SocialItem = {
  title: string;
  path: string;
  icon: ReactNode;
  disabled?: boolean;
};

export const SOCIAL_LINKS: SocialItem[] = [
  {
    title: 'X',
    path: TWITTER_LINK,
    icon: TwitterIconHeader,
  },
  {
    title: 'YouTube',
    path: YOUTUBE_LINK,
    icon: YoutubeIconHeader,
  },
  {
    title: 'Discord',
    path: DISCORD_LINK,
    icon: DiscordIconHeader,
  },
  {
    title: 'Telegram',
    path: TELEGRAM_LINK,
    icon: TelegramIconHeader,
  },
  // {
  //   title: 'Instagram',
  //   path: INSTAGRAM_LINK,
  //   icon: InstagramIconHeader,
  // },
  // {
  //   title: 'TikTok',
  //   path: TIKTOK_LINK,
  //   icon: TikTokIconHeader,
  // },
  // {
  //   title: 'Facebook',
  //   path: FACEBOOK_LINK,
  //   icon: FacebookIconHeader,
  // },
];
